module.exports = __webpack_public_path__ + "media/98.9f81e97d.mp3";